import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

let installPrompt = null;

document.addEventListener("DOMContentLoaded", () => {
	document.getElementById("copyToken").addEventListener("click", copyText);
	document.getElementById("register").addEventListener("click", register);
	document.getElementById("install").addEventListener("click", async () => {
		if (!installPrompt) {
			return;
		}
		const result = await installPrompt.prompt();
		console.log(`Install prompt was: ${result.outcome}`);
	});
})

window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault();
  installPrompt = event;
});

function copyText() {
	const input = document.getElementById("token");
	input.select();
	input.setSelectionRange(0, 99999); // For mobile devices

	navigator.clipboard.writeText(input.value).then(() => {
		const alertBox = document.getElementById("copyAlert");
		alertBox.classList.remove("d-none");
		setTimeout(() => {
			alertBox.classList.add("d-none");
		}, 2000);
	});
}

function register() {
	// Initialize Firebase Cloud Messaging and get a reference to the service
	let text = document.getElementById("multiText").value;
	text = text.replace(/^\s*(\S*?):/mg, '"$1":');
	let options = {};
	try {
		options = JSON.parse(text);
	} catch (e) {
		alert(e);
		return;
	}
	const myFirebase = initializeApp(options);
	const messaging = getMessaging(myFirebase);

	console.log('Requesting permission...');
	Notification.requestPermission().then((permission) => {
		if (permission === 'denied') {
			alert('Notification permission denied.');
		}
		else if (permission === 'granted') {
			console.log('Notification permission granted.');
			navigator.serviceWorker
			.register(  new URL('service-worker.js', import.meta.url),
			{type: 'module'})
			.then((registration) => {
				console.log('Registration successful, scope is:', registration.scope);			
				getToken(messaging, { vapidKey: document.getElementById("vapidKey").value, serviceWorkerRegistration: registration }).then((currentToken) => {
					if (currentToken) {
						console.log('currentToken: ', currentToken);
						document.getElementById("token").value = currentToken;
					} else {
						console.log('No registration token available. Request permission to generate one.');
					}
				}).catch((err) => {
					console.log('An error occurred while retrieving token. ', err);
				});
			});
		}
	});
}